module.exports = __webpack_public_path__ + "files/0037da5347f672f755d795a70a9c0eba.png";